import React, { Component } from "react";
import { multiLanguage } from "../../hoc";
import { Slider } from "../../components";
import { gifImage, bgImage } from "../../data/SanctuaryClub/exchange";

import arrowLeft from "../../components/images/icons/arrowLeft.svg";
import arrowRight from "../../components/images/icons/arrowRight.svg";

const createArrowButton = (direction) => {
  return (props) => {
    const { className, style, onClick } = props;
    return (
      <button className={className} style={style} onClick={onClick}>
        <img
          className="arrow-button-image"
          src={direction === "left" ? arrowLeft : arrowRight}
          alt=""
        />
      </button>
    );
  };
};

const NextButton = createArrowButton("right");
const PrevButton = createArrowButton("left");

@multiLanguage()
export default class Exchange extends Component {
  render() {
    return (
      <div
        className="section8-exchange"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="block-content">
          <h2>The Exchange Programme</h2>
          <p>
            Owners whose properties are managed under a hotel branded rental
            scheme are allowed to exchange part of their annual entitlement for
            a complimentary stay at any destination within The Santuary Club
            network
          </p>
          <h3>The Exchange Process</h3>
          <div className="container-slider">
            <Slider
              type="type-background"
              sliderRef={this.sliderRef}
              items={gifImage}
              settings={{
                arrows: true,
                dots: true,
                fade: false,
                nextArrow: <NextButton />,
                prevArrow: <PrevButton />,
              }}
              uiRenderer={(item, index) => {
                return (
                  <div className="container-content-img">
                    <div
                      className="img-background"
                      style={{
                        backgroundImage: `url(${item.image})`,
                        backgroundPosition: item.backgroundPosition,
                      }}
                    />
                    <p>{item.text}</p>
                  </div>
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Exchange.js